import type { HelpFile } from '../../types/help'
import { CalendarTestIds } from '../../../testids/CalendarTestIds'

export const calendarHelp: HelpFile = {
  docPage: '/docs/reference/calendar',
  texts: {
    [CalendarTestIds.calendarLabel]:
      'Aktueller Monat und Jahr — Klick wechselt zwischen Monats-, Jahres- und Jahrzehnt-Ansicht.',
    [CalendarTestIds.calendarPrevMonth]: null,
    [CalendarTestIds.calendarNextMonth]: null,
    [CalendarTestIds.calendarPrevYear]: null,
    [CalendarTestIds.calendarNextYear]: null,
    [CalendarTestIds.calendarPrevDecade]: null,
    [CalendarTestIds.calendarNextDecade]: null,
    [CalendarTestIds.calendarYearRange]: null,
  },
}
